import { S3NetworkError } from './S3NetworkError';
import { Api403ForbiddenError } from './api403ForbiddenError';
import { ConditionalRequestFailedError } from './conditionalRequestFailedError';
import { SessionError } from './sessionError';

import type { Draft, SerializedError } from '@reduxjs/toolkit';

import { version } from '@/constants/env';
import { api, service } from '@/share';

const reportUnexpectedError = (title: string, stack: string) => {
  const deviceInfo = service.device.getDeviceInfo();
  const message = api.logger.outputLog();
  api.wagakoAppApi.errorReport({
    title: `v${version}:${title}`,
    content: `[Error]\n${stack}\n[Log]\n${message}\n[Device]\n${JSON.stringify(deviceInfo)}`,
  })
    // eslint-disable-next-line no-console
    .then(() => console.log('Error Report End'))
    // eslint-disable-next-line no-console
    .catch((e) => console.error(e));
  api.logger.clearLog();
};

/**
 * eHandle
 * @param _state _state
 * @param type type
 * @param error error
 */
export const eHandle = (_state: Draft<any>, type: string, error: SerializedError) => {
  const msg = `${type}:${error.message || ''}:${error.stack || ''}`;
  api.logger.error(msg);
  reportUnexpectedError(error.message as string, error.stack || '');
};

/**
 * セッションエラーかどうかを判定する
 * @param name 名前
 * @param message メッセージ
 * @returns エラーかどうか
 */
export const checkSessionError = (
  name: string,
  message: string,
) => name === SessionError.name
|| name.includes('Token has expired')
|| name.includes('SessionError in ')
|| message.includes('Token has expired')
  || message.includes('SessionError in ');

/**
 * S3ネットワークエラーかどうかを判定する
 * @param name 名前
 * @param _message メッセージ
 * @returns エラーかどうか
 */
export const checkS3NetworkError = (
  name: string,
  _message: string,
) => name === S3NetworkError.name;

/**
 * ネットワークエラーかを判定する
 * @param name 名前
 * @param message メッセージ
 * @returns エラーかどうか
 */
export const checkNetworkError = (
  name: string,
  message: string,
) => (name === 'TypeError' && message === 'Network request failed')
  || (name === 'TypeError' && message === 'Failed to fetch');

/**
 * S3403権限エラーかを判定する
 * @param name 名前
 * @param message メッセージ
 * @returns エラーかどうか
 */
export const checkApi403ForbiddenError = (
  name: string,
  _message: string,
) => name === Api403ForbiddenError.name;

/**
 * アップデート条件エラーかを判定する
 * @param name 名前
 * @param message メッセージ
 * @returns エラーかどうか
 */
export const checkConditionalRequestFailedError = (
  name: string,
  _message: string,
) => name === ConditionalRequestFailedError.name;
